<template>
    <div class="scholarship-form">
		<h3 class="scholarship-form-header" id="estimator">Scholarship Estimator&#160;</h3>
		<div class="d-flex justify-content-center">
			<div class="form-check form-check-inline">
				<input class="form-check-input" name="scholarship_student_type" type="radio" ref="scholarship_firstyearstudent_radio" value="firstYear" v-model="studentType" id="scholarship_firstyearstudent_radio">
				<label class="form-check-label" for="scholarship_firstyearstudent_radio">First Year Student</label>
			</div>
			<div class="form-check form-check-inline">
				<input class="form-check-input" name="scholarship_student_type" type="radio" ref="scholarship_transferstudent_radio" value="transfer" v-model="studentType" id="scholarship_transferstudent_radio">
				<label class="form-check-label" for="scholarship_transferstudent_radio">Transfer Student</label>
			</div>
		</div>
		<!-- Range sliders for ACT/SAT Score and GPA -->
		<div class="form-row leftfix" ref="scholarship_firstyearstudent_div" id="scholarship_firstyearstudent_div">
			<div v-if="studentType === 'firstYear'">
				<div class="col-lg-10">
					<p>To calculate your estimated award amount, enter your score, and non-weighted cumulative GPA. 
						For each option, you can choose your composite score on the ACT or SAT (ERW+M only)</p>
					<h5 class="text-center">ACT/SAT Score: <span>{{ act_score }}</span></h5>
					<label for="actslider"></label>
					<div class="slider-component" id="actslider">
						<div class="slidecontainer">
							<span class="act-minus" v-on:click="decrementActScore"></span>
							<input class="slider toggle" type="range" ref="actslider" min="1" max="36" step="1" v-model="act_score" id="actslider">
							<span class="act-plus" v-on:click="incrementActScore"></span>
						</div>
					</div>
				</div>
				<br>
				<div class="col-lg-10">
					<h5 class="text-center">First Year GPA: <span>{{ firstyear_gpa_score }}</span></h5>
					<label for="gpaslider"></label>
					<div class="slider-component" id="gpaslider">
						<div class="slidecontainer">
							<span class="gpa-minus" v-on:click="decrementFirstYearGpaScore"></span>
							<input class="slider" type="range" ref="gpaslider" min="1.0" max="4.0" step="0.05" v-model.number="firstyear_gpa_score" id="gpaslider" @change="updateFirstGpa">
							<span class="gpa-plus" v-on:click="incrementFirstYearGpaScore"></span>
						</div>
					</div>
				</div>
				<br>
				<form @submit.prevent="calculateScholarship" method="POST" id="scholarship-form"> 
					<div class="form-group text-center">
						<button type="submit" class="btn btn-primary btn-sm">Calculate Scholarship</button>
					</div>
				</form>
				<br>
				<div v-if="scholarship_value">
					<br>
					<div v-if="firstyear_level === 1">
						<div class="agree-wrapper">
							<p>
								I understand that the information I am about to preview is an unofficial offer due to self-reported 
								information. This information is true and correct to the best of my knowledge and ability. 
								I understand that Scholarship Services at FHSU will verify all self-reported documentation. 
								I further understand that if I'm reporting my ACT/SAT superscore, I will need to send all 
								standardized test scores for verification of award.
							</p>
							<!-- Terms and Conditions -->
							<div class="d-flex justify-content-center">
								<label class="agree-label" for="agree">
									<input type="checkbox" v-model="agreedToTermsFirst" id="agree"/>
									I Understand
								</label>
							</div>
						</div>
						<br>
						<p>Congratulations! As a first time student, your ACT/SAT and GPA make for the <b>Tiger Pride Scholarship</b> worth <b>$15,000</b>. 
							<br> You will receive <b>$3,750</b> your first year, and it is renewable for three years.</p>
						<p>
							<a class="btn btn-primary btn-sm" :href="'https://www.fhsu.edu/finaid/scholarships/' + cta_link" v-if="agreedToTermsFirst">Claim Scholarship</a>
						</p>
					</div>
					<div v-else-if="firstyear_level === 2">
						<div class="agree-wrapper">
							<p>
								I understand that the information I am about to preview is an unofficial offer due to self-reported 
								information. This information is true and correct to the best of my knowledge and ability. 
								I understand that Scholarship Services at FHSU will verify all self-reported documentation. 
								I further understand that if I'm reporting my ACT/SAT superscore, I will need to send all 
								standardized test scores for verification of award.
							</p>
							<!-- Terms and Conditions -->
							<div class="d-flex justify-content-center">
								<label class="agree-label" for="agree">
									<input type="checkbox" v-model="agreedToTermsFirst" id="agree"/>
									I Understand
								</label>
							</div>
						</div>
						<br>
						<p>Congratulations! As a first time student, your ACT/SAT and GPA make for the <b>Victor E. Scholarship</b> worth <b>$11,000</b>. 
							<br> You will receive <b>$2,750</b> your first year, and it is renewable for three years.</p>
						<p>
							<a class="btn btn-primary btn-sm" :href="'https://www.fhsu.edu/finaid/scholarships/' + cta_link" v-if="agreedToTermsFirst">Claim Scholarship</a>
						</p>
					</div>
					<div v-else-if="firstyear_level === 3">
						<div class="agree-wrapper">
							<p>
								I understand that the information I am about to preview is an unofficial offer due to self-reported 
								information. This information is true and correct to the best of my knowledge and ability. 
								I understand that Scholarship Services at FHSU will verify all self-reported documentation. 
								I further understand that if I'm reporting my ACT/SAT superscore, I will need to send all 
								standardized test scores for verification of award.
							</p>
							<!-- Terms and Conditions -->
							<div class="d-flex justify-content-center">
								<label class="agree-label" for="agree">
									<input type="checkbox" v-model="agreedToTermsFirst" id="agree"/>
									I Understand
								</label>
							</div>
						</div>
						<br>
						<p>Congratulations! As a first time student, your ACT/SAT and GPA make for the <b>Black & Gold Scholarship</b> worth <b>$8,000</b>. 
							<br> You will receive <b>$2,000</b> your first year, and it is renewable for three years.</p>
						<p>
							<a class="btn btn-primary btn-sm" :href="'https://www.fhsu.edu/finaid/scholarships/' + cta_link" v-if="agreedToTermsFirst">Claim Scholarship</a>
						</p>
					</div>
					<div v-else-if="firstyear_level === 4">
						<div class="agree-wrapper">
							<p>
								I understand that the information I am about to preview is an unofficial offer due to self-reported 
								information. This information is true and correct to the best of my knowledge and ability. 
								I understand that Scholarship Services at FHSU will verify all self-reported documentation. 
								I further understand that if I'm reporting my ACT/SAT superscore, I will need to send all 
								standardized test scores for verification of award.
							</p>
							<!-- Terms and Conditions -->
							<div class="d-flex justify-content-center">
								<label class="agree-label" for="agree">
									<input type="checkbox" v-model="agreedToTermsFirst" id="agree"/>
									I Understand
								</label>
							</div>
						</div>
						<br>
						<p>Congratulations! As a first time student, your ACT/SAT and GPA make for the <b>Hays City Scholarship</b> worth <b>$6,000</b>. 
							<br> You will receive <b>$1,500</b> your first year, and it is renewable for three years.</p>
						<p>
							<a class="btn btn-primary btn-sm" :href="'https://www.fhsu.edu/finaid/scholarships/' + cta_link" v-if="agreedToTermsFirst">Claim Scholarship</a>
						</p>
					</div>
					<div v-else-if="firstyear_level === 5">
						<p>
							According to the scores you entered, you don't currently qualify for an automatic freshman scholarship.
							If you have any questions, please fill out the form below and our admissions staff will be happy to visit 
							with you about other potential scholarship opportunities.
						</p>
						<p>
							<a class="btn btn-primary btn-sm" href="#">Contact Us</a>
						</p>
					</div>
					<div v-else>
						<p>ACT/SAT and GPA are to low.</p>
					</div>
				</div>

				<div id="additional-scholarships">
					<p><em>
						*All first-time, full-time, on-campus Freshman ACT/SAT Scholarships are renewable for three additional years if at least a 3.3 FHSU cumulative GPA is maintained. 
						FHSU must receive your test scores by June 30, 2022  to be eligible.
					</em></p>
				</div>
			</div>

			<div v-else>
				<div class="col-lg-10">
					<p>To calculate your estimated award amount, enter your non-weighted cumulative GPA.</p>
					<h5 class="text-center">Transfer GPA: <span>{{ transfer_gpa_score }}</span></h5>
					<label for="gpatransferslider"></label>
					<div class="slider-component" id="gpatransferslider">
						<div class="slidecontainer">
							<span class="gpatransfer-minus" v-on:click="decrementTransferGpaScore"></span>
							<input class="slider" type="range" ref="gpatransferslider" min="1.0" max="4.0" step="0.05" v-model.number="transfer_gpa_score" id="gpatransferslider" @change="updateTransferGpa">
							<span class="gpatransfer-plus" v-on:click="incrementTransferGpaScore"></span>							
						</div>
					</div>
				</div>
				<br>
				<form @submit.prevent="calculateScholarship" method="POST" id="scholarship-form"> 
					<div class="form-group text-center">
						<button type="submit" class="btn btn-primary btn-sm">Calculate Scholarship</button>
					</div>
				</form>
				<br>
				<div v-if="transfer_value">
					<div v-if="transfer_level === 1">
						<div class="agree-wrapper">
							<p>
								I understand that the information I am about to preview is an unofficial offer due to self-reported 
								information. This information is true and correct to the best of my knowledge and ability. 
								I understand that Scholarship Services at FHSU will verify all self-reported documentation. 
								I further understand that if I'm reporting my ACT/SAT superscore, I will need to send all 
								standardized test scores for verification of award.
							</p>
							<!-- Terms and Conditions -->
							<div class="d-flex justify-content-center">
								<label class="agree-label" for="agree">
									<input type="checkbox" v-model="agreedToTermsTransfer" id="agree"/>
									I Understand
								</label>
							</div>
						</div>
						<br>
						<p>Congratulations!  As a transfer student, your GPA makes you eligible for a university scholarship worth <b>$500</b>.</p>
						<p><a class="btn btn-primary btn-sm" :href="'https://www.fhsu.edu/finaid/scholarships/' + cta_link" v-if="agreedToTermsTransfer">Claim Scholarship</a></p>
					</div>
					<div v-else-if="transfer_level === 2">
						<div class="agree-wrapper">
							<p>
								I understand that the information I am about to preview is an unofficial offer due to self-reported 
								information. This information is true and correct to the best of my knowledge and ability. 
								I understand that Scholarship Services at FHSU will verify all self-reported documentation. 
								I further understand that if I'm reporting my ACT/SAT superscore, I will need to send all 
								standardized test scores for verification of award.
							</p>
							<!-- Terms and Conditions -->
							<div class="d-flex justify-content-center">
								<label class="agree-label" for="agree">
									<input type="checkbox" v-model="agreedToTermsTransfer" id="agree"/>
									I Understand
								</label>
							</div>
						</div>
						<br>
						<p>Congratulations!  As a transfer student, your GPA makes you eligible for a university scholarship worth <b>$1000</b>.</p>
						<p><a class="btn btn-primary btn-sm" :href="'https://www.fhsu.edu/finaid/scholarships/' + cta_link" v-if="agreedToTermsTransfer">Claim Scholarship</a></p>
					</div>
					<div v-else-if="transfer_level === 3">
						<div class="agree-wrapper">
							<p>
								I understand that the information I am about to preview is an unofficial offer due to self-reported 
								information. This information is true and correct to the best of my knowledge and ability. 
								I understand that Scholarship Services at FHSU will verify all self-reported documentation. 
								I further understand that if I'm reporting my ACT/SAT superscore, I will need to send all 
								standardized test scores for verification of award.
							</p>
							<!-- Terms and Conditions -->
							<div class="d-flex justify-content-center">
								<label class="agree-label" for="agree">
									<input type="checkbox" v-model="agreedToTermsTransfer" id="agree"/>
									I Understand
								</label>
							</div>
						</div>
						<br>
						<p>Congratulations!  As a transfer student, your GPA makes you eligible for a university scholarship worth <b>$1500</b>.</p>
						<p><a class="btn btn-primary btn-sm" :href="'https://www.fhsu.edu/finaid/scholarships/' + cta_link" v-if="agreedToTermsTransfer">Claim Scholarship</a></p>
					</div>
					<div v-else-if="transfer_level === 4">
						<p>According to the GPA you entered, you are not eligible for an automatic scholarship, 
						but please check out our additional scholarship opportunities. If you have any questions, 
						please don't hesitate to contact us.</p>
						<p>
							<a class="btn btn-primary btn-sm" href="#">Contact Us</a>
						</p>
					</div>
					<div v-else>
						<p>GPA is to low.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    data() {
        return {
			studentType: 'firstYear',
            act_score: 0,
			firstyear_gpa_score: 0,
			transfer_gpa_score: 0,
			
			firstyear_level: 0,
			transfer_level: 0,
			scholarship_name: 0,
			scholarship_value: 0,
			scholarship_year_value: 0,
			transfer_value: 0,

			cta_link: '',
			agreedToTermsFirst: false,
			agreedToTermsTransfer: false,

		};
    },
    methods: {
		incrementActScore() {
			if (this.act_score >= 36) return;
			this.act_score++;
		},
		decrementActScore() {
			if (this.act_score <= 1) return;
			this.act_score--;
		},
		incrementFirstYearGpaScore() {
			if (this.firstyear_gpa_score >= 4.0) return;
			this.firstyear_gpa_score = Number((this.firstyear_gpa_score + 0.05).toFixed(2));
		},
		decrementFirstYearGpaScore() {
			if (this.firstyear_gpa_score <= 1.0) return;
			this.firstyear_gpa_score = Number((this.firstyear_gpa_score - 0.05).toFixed(2));
		},
		updateFirstGpa(event) {
			const value = event.target.value;
			this.firstyear_gpa_score = Number(value.toFixed(2));
		},
		incrementTransferGpaScore() {
			if (this.transfer_gpa_score >= 4.0) return;
			this.transfer_gpa_score = Number((this.transfer_gpa_score + 0.05).toFixed(2));
		},
		decrementTransferGpaScore() {
			if (this.transfer_gpa_score <= 1.0) return;
			this.transfer_gpa_score = Number((this.transfer_gpa_score - 0.05).toFixed(2));
		},
		updateTransferGpa(event) {
			const value = event.target.value;
			this.transfer_gpa_score = Number(value.toFixed(2));
		},
		calculateScholarship() {
			if (this.studentType === 'firstYear') {
				this.Update_NewStudent_Index_Score();
			} else {
				this.Update_TransferStudent_Score();
			}

			// If they choose FIRST YEAR student
			this.scholarship_firstyearstudent_radio.addEventListener('click', () => {
				this.scholarship_firstyearstudent_div.classList.remove('hidden');
				this.scholarship_transferstudent_div.classList.add('hidden');
				this.Update_NewStudent_Index_Score();
			});

			// If they choose TRANSFER student
			this.scholarship_transferstudent_radio.addEventListener('click', () => {
				this.scholarship_firstyearstudent_div.classList.remove('hidden');
				this.scholarship_transferstudent_div.classList.add('hidden');
				this.Update_TransferStudent_Score();
			});
		},

		// Gets values from the form for First Year GPA score and validates
		Get_FirstYearGPA_Score() {
			this.firstyear_gpa_score = parseFloat(this.gpaslider.value);
		},

		// Gets values from the form for Transfer GPA score and validates
		Get_TransferGPA_Score() {
			this.transfer_gpa_score = parseFloat(this.gpatransferslider.value);
		},

		Update_NewStudent_Index_Score() {
			if ((this.act_score >= 27) || this.firstyear_gpa_score >= 2.95) {
				this.firstyear_level = 1;
				this.scholarship_name = "Tiger Pride Scholarship";
				this.scholarship_value = 15000;
				this.scholarship_year_value = 3750;
				this.cta_link = 'tiger-pride-scholarship';
			} else if ((this.act_score >= 23) || this.firstyear_gpa_score >= 2.55) {
				this.firstyear_level = 2;
				this.scholarship_value = 11000;
				this.scholarship_year_value = 2750;
				this.scholarship_name = "Victor E. Scholarship";
				this.cta_link = "victor-e-scholarship";
			} else if ((this.act_score >= 20) || this.firstyear_gpa_score >= 2.25) {
				this.firstyear_level = 3;
				this.scholarship_value = 8000;
				this.scholarship_year_value = 2000;
				this.scholarship_name = "Black & Gold Scholarship";
				this.cta_link = "black-gold-scholarship";
			} else if ((this.act_score >= 18) || this.firstyear_gpa_score >= 2.20) {
				this.firstyear_level = 4;
				this.scholarship_name = "Hays City Scholarship";
				this.scholarship_value = 6000;
				this.scholarship_year_value = 1500;
				this.cta_link = "hays-city-scholarship";
			} else if ((this.act_score >= 17) || this.firstyear_gpa_score >= 2.15) {
				this.firstyear_level = 5;
				this.scholarship_value = 2;
			} else {
				this.firstyear_level = -1;
				this.scholarship_value = 1;
			}
		},

		Update_TransferStudent_Score() {
			if (this.transfer_gpa_score >= 3.50) {
				this.transfer_level = 1;
				this.transfer_value = 1500;
				this.cta_link = 'transfer-1500';
			} else if (this.transfer_gpa_score >= 3.00) {
				this.transfer_level = 2;
				this.transfer_value = 1000;
				this.cta_link = 'transfer-1000';
			} else if (this.transfer_gpa_score >= 2.50) {
				this.transfer_level = 3;
				this.transfer_value = 500;
				this.cta_link = 'transfer-500';
			} else if (this.transfer_gpa_score >= 2.00) {
				this.transfer_level = 4;
				this.transfer_value = 2;
			} else {
				this.transfer_level= -1;
				this.transfer_value = 1;
			}
		},
    },
};
</script>